import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Pagetitle from "../Components/Pagetitle";
import FeedbackForm from "../Components/FeedbackForm";

function Reviewus() {
  return (
    <>
      <main className="container-fluid">
        <Header />
        <Pagetitle />
        <div className="row  px-sm-5 py-5">
          <div className="text-center about-title">
            <h1 className=""> WE APPRECIATE YOUR REVIEW!</h1>
            <p>
              Your review will help us to improve our quality of products, and
              customer services.
            </p>
          </div>
          <FeedbackForm /> 
        </div>
        <Footer />
      </main>
      {/* <div className="row">
                  <div className="col-md-6 mb-3">
                    <div className="form-floating">
                      <select
                        className="form-control bg-white"
                        name="product"
                        value={formData.product}
                        onChange={handleChange}
                        style={{ cursor: "pointer" }}
                        required
                      >
                        <option value="">Choose a product you bought recently</option>
                        <option value="Product 1">Product 1</option>
                        <option value="Product 2">Product 2</option>
                        <option value="Product 3">Product 3</option>
                        <option value="Product 4">Product 4</option>
                      </select>
                      <label>Choose a product you bought recently.</label>
                    </div>
                  </div>

                  <div className="col-md-6 mb-3">
                    <div className="form-floating">
                      <select
                        className="form-control bg-white"
                        name="rating"
                        value={formData.rating}
                        onChange={handleChange}
                        required
                      >
                        <option value="1">1 Star (Taste is very bad)</option>
                        <option value="2">2 Star (Taste is bad)</option>
                        <option value="3">3 Star (Taste is average)</option>
                        <option value="4">4 Star (Taste is good)</option>
                        <option value="5">5 Star (Taste is very delicious)</option>
                      </select>
                      <label>Rate our overall services.</label>
                    </div>
                  </div>
                </div> */}

      {/* <div className="col-md-4 mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <input
                      type="file"
                      className="form-control"
                      onChange={handleFileChange}
                    />
                  </div> */}
    </>
  );
}

export default Reviewus;
